import CategoryAdding from './modules/CategoryAdding';
import CategoryModifySearchKeywords from './modules/CategoryModifySearchKeywords';
import DisplayDalphaKeyword from './modules/DisplayDalphaKeyword';
import CategoryModifyReviewKeywords from './modules/CategoryModifyReviewKeywords';
import EventCommentList from './modules/EventCommentList';
import SelectProductForEventWinner from './modules/SelectProductForEventWinner';
import PushTargetDirect from './modules/PushTargetDirect';
import PushTargetManage from './modules/PushTargetManage';
import SpecialBoxProductSearch from './modules/SpecialBoxProductSearch';
import SpecialBoxGoodsSearch from './modules/SpecialBoxGoodsSearch';
import ProductIngredientController from './modules/ProductIngredientController';
import ProductCategoryAdd from './modules/ProductCategoryAdd';
import ProductReviewMove from './modules/ProductReviewMove';
import ProductReviewMoveResult from './modules/ProductReviewMoveResult';
import ExcelDownList from './modules/ExcelDownList';
import ProductStoreChange from './modules/ProductStoreChange';
import ProductBrandChange from './modules/ProductBrandChange';
import RegisterSimpleList from './modules/RegisterSimpleList';
import RegisterMissionList from './modules/RegisterMissionList';
import ReviewAnalysis from './modules/ReviewAnalysis';
import ReviewListByWord from './modules/ReviewListByWord';
import CastCommentedUser from '@/components/modals/modules/CastCommentedUser';
import CastInterestUser from '@/components/modals/modules/CastInterestUser';
import CastLikeUser from '@/components/modals/modules/CastLikeUser';
import AdDetailTotal from './modules/AdDetailTotal';
import AdminModify from './modules/AdminModify';
import AdminOtp from './modules/AdminOtp';
import AddIp from './modules/AddIp';
import DepartmentAssign from './modules/DepartmentAssign';
import ShowHistory from './modules/ShowHistory';
import ThemePreview from './modules/ThemePreview';
import CollectionPreview from './modules/CollectionPreview';
import ReviewerGrade from './modules/ReviewerGrade';
import WriterSearch from './modules/WriterSearch';
import ProductChangeHistory from './modules/ProductChangeHistory';
import BatchBlind from './modules/BatchBlind';
import ProductGroup from './modules/ProductGroup';
import BatchReviewProduct from './modules/BatchReviewProduct';
import MainCateSet from './modules/MainCateSet';
import ToBlindBatch from './modules/ToBlindBatch';
import SetLink from './modules/SetLink.vue';
import StampCommentList from './modules/StampCommentList.vue';
import CastPdtList from './modules/CastPdtList.vue';
import EventWinnerHistoryList from './modules/EventWinnerHistoryList.vue';
import CremaLinkAccount from './modules/CremaLinkAccount.vue';
import SelectProductForEventWinnerRemove from './modules/SelectProductForEventWinnerRemove.vue';
import BrandStoreChange from './modules/BrandStoreChange.vue';
import EventProductList from './modules/EventProductList.vue';
import ExpressionChange from './modules/ExpressionChange.vue';
import QnaStateBatchBlock from './modules/QnaStateBatchBlock.vue';

export default {
	CastCommentedUser: {
		module: CastCommentedUser,
		id: 'CastCommentedUser',
		contsTitle: '캐스트 댓글 작성 회원',
		size: 'wide',
	},
	CastInterestUser: {
		module: CastInterestUser,
		id: 'CastInterestUser',
		contsTitle: '캐스트 관심 회원',
		size: 'wide',
	},
	CastLikeUser: {
		module: CastLikeUser,
		id: 'CastLikeUser',
		contsTitle: '캐스트 좋아요 회원',
		size: 'wide',
	},
	CategoryAdding: {
		module: CategoryAdding,
		id: 'CategoryAdding',
		mainBtnText: ['등록', '취소'],
	},
	CategoryModifySearchKeywords: {
		module: CategoryModifySearchKeywords,
		id: 'CategoryModifySearchKeywords',
		mainBtnText: ['적용', '취소'],
		size: 'wide',
		contsTitle: '검색 키워드 수정',
	},
	DisplayDalphaKeyword: {
		module: DisplayDalphaKeyword,
		id: 'DisplayDalphaKeyword',
		mainBtnText: ['적용', '취소'],
		size: 'wide',
		contsTitle: '달파 비노출 키워드 수정',
	},
	CategoryModifyReviewKeywords: {
		module: CategoryModifyReviewKeywords,
		id: 'CategoryModifyReviewKeywords',
		mainBtnText: ['적용', '취소'],
		size: 'wide',
		contsTitle: '리뷰 키워드 수정',
	},
	EventCommentList: {
		module: EventCommentList,
		id: 'EventCommentList',
		mainBtnText: null,
		size: 'wide',
		contsTitle: '이벤트 댓글 리스트',
	},
	SelectProductForEventWinner: {
		module: SelectProductForEventWinner,
		id: 'SelectProductForEventWinner',
		mainBtnText: null,
		contsTitle: '선택한 사용자 그룹을 추가할 제품을 선택해주세요.',
	},
	PushTargetDirect: {
		module: PushTargetDirect,
		id: 'PushTargetDirect',
		mainBtnText: null,
		hasXBtn: true,
		size: 'wide',
		contsTitle: '푸시 발송 대상 직접 추가',
	},
	PushTargetManage: {
		module: PushTargetManage,
		id: 'PushTargetManage',
		mainBtnText: null,
		hasXBtn: true,
		size: 'wide',
		contsTitle: '푸시 발송 대상 리스트',
	},
	SpecialBoxProductSearch: {
		module: SpecialBoxProductSearch,
		id: 'SpecialBoxProductSearch',
		mainBtnText: null,
		hasXBtn: true,
		size: 'wide',
		contsTitle: '상품검색',
	},
	SpecialBoxGoodsSearch: {
		module: SpecialBoxGoodsSearch,
		id: 'SpecialBoxGoodsSearch',
		mainBtnText: null,
		hasXBtn: true,
		size: 'wide',
		contsTitle: '제품검색',
	},
	ProductIngredientController: {
		module: ProductIngredientController,
		id: 'ProductIngredientController',
		mainBtnText: null,
		hasXBtn: true,
		size: 'wide',
		contsTitle: '제품 성분 매핑',
	},
	ProductCategoryAdd: {
		module: ProductCategoryAdd,
		id: 'ProductCategoryAdd',
		mainBtnText: null,
		hasXBtn: true,
		size: 'wide',
		contsTitle: '카테고리 추가하기',
	},
	ProductReviewMove: {
		module: ProductReviewMove,
		id: 'ProductReviewMove',
		mainBtnText: null,
		hasXBtn: true,
		contsTitle: '리뷰 이동',
	},
	ProductReviewMoveResult: {
		module: ProductReviewMoveResult,
		id: 'ProductReviewMoveResult',
		mainBtnText: null,
		hasXBtn: true,
		contsTitle: '작업이 완료되었습니다.',
	},
	ExcelDownList: {
		module: ExcelDownList,
		id: 'ExcelDownList',
		mainBtnText: null,
		hasXBtn: true,
		fullHeight: true,
		contsTitle: 'Download',
	},
	ProductStoreChange: {
		module: ProductStoreChange,
		id: 'ProductStoreChange',
		mainBtnText: null,
		hasXBtn: true,
		fullHeight: true,
		contsTitle: '판매처 일괄 변경',
	},
	ProductBrandChange: {
		module: ProductBrandChange,
		id: 'ProductBrandChange',
		mainBtnText: null,
		hasXBtn: true,
		fullHeight: true,
		contsTitle: '브랜드 일괄 변경',
	},
	RegisterSimpleList: {
		module: RegisterSimpleList,
		id: 'RegisterSimpleList',
		mainBtnText: null,
		contsTitle: null,
	},
	RegisterMissionList: {
		module: RegisterMissionList,
		id: 'RegisterMissionList',
		mainBtnText: null,
		contsTitle: '미션 리스트',
		size: 'wide',
	},
	ReviewAnalysis: {
		module: ReviewAnalysis,
		id: 'ReviewAnalysis',
		mainBtnText: null,
		size: 'wide',
	},
	ReviewListByWord: {
		module: ReviewListByWord,
		id: 'ReviewListByWord',
		mainBtnText: null,
		size: 'wide',
	},
	AdDetailTotal: {
		module: AdDetailTotal,
		id: 'AdDetailTotal',
		size: 'wide',
	},
	AdminModify: {
		module: AdminModify,
		id: 'AdminModify',
		contsTitle: '관리자회원 정보수정',
	},
	AdminOtp: {
		module: AdminOtp,
		id: 'AdminOtp',
		contsTitle: '스토어에서 google otp를 검색하고 다운 받으세요',
	},
	AddIp: {
		module: AddIp,
		id: 'AddIp',
	},
	DepartmentAssign: {
		module: DepartmentAssign,
		id: 'DepartmentAssign',
		contsTitle: '추가할 부서명을 입력',
	},
	ShowHistory: {
		module: ShowHistory,
		id: 'ShowHistory',
		contsTitle: '',
		size: 'wide',
	},
	ThemePreview: {
		module: ThemePreview,
		id: 'ThemePreview',
		contsTitle: '',
		size: 'web-preview',
	},
	CollectionPreview: {
		module: CollectionPreview,
		id: 'CollectionPreview',
		contsTitle: '',
		size: 'web-preview',
	},
	ReviewerGrade: {
		module: ReviewerGrade,
		id: 'ReviewerGrade',
		contsTitle: '리뷰어 등급',
		size: 'wide',
	},
	WriterSearch: {
		module: WriterSearch,
		id: 'WriterSearch',
		contsTitle: '대상 추가하기',
		size: 'wide',
	},
	ProductChangeHistory: {
		module: ProductChangeHistory,
		id: 'ProductChangeHistory',
		contsTitle: '제품 변경이력',
		size: 'wide',
	},
	BatchBlind: {
		module: BatchBlind,
		id: 'BatchBlind',
		contsTitle: '블라인드 일괄처리',
	},
	ProductGroup: {
		module: ProductGroup,
	},
	BatchReviewProduct: {
		module: BatchReviewProduct,
		id: 'BatchReviewProduct',
		contsTitle: '리뷰 일괄 이동',
	},
	MainCateSet: {
		module: MainCateSet,
		id: 'MainCateSet',
		contsTitle: '캐스트 대표 카테고리 관리',
		size: 'wide',
		hasXBtn: true,
		fullHeight: true,
	},
	ToBlindBatch: {
		module: ToBlindBatch,
		id: 'ToBlindBatch',
	},
	SetLink: {
		module: SetLink,
		id: 'SetLink',
	},
	CastPdtList: {
		module: CastPdtList,
		id: 'CastPdtList',
		contsTitle: '첨부된 제품',
		size: 'wide',
	},
	StampCommentList: {
		module: StampCommentList,
		id: 'StampCommentList',
		contsTitle: '출석체크 댓글',
		size: 'wide',
		fullHeight: true,
	},
	EventWinnerHistoryList: {
		module: EventWinnerHistoryList,
		id: 'EventWinnerHistoryList',
		contsTitle: '당첨이력',
		size: 'wide',
	},
	CremaLinkAccount: {
		module: CremaLinkAccount,
		id: 'CremaLinkAccount',
		contsTitle: '계정신청 검수 확인',
	},
	SelectProductForEventWinnerRemove: {
		module: SelectProductForEventWinnerRemove,
		id: 'SelectProductForEventWinnerRemove',
		mainBtnText: null,
		contsTitle: '선택한 사용자를 삭제할 제품을 선택해 주세요.',
	},
	BrandStoreChange: {
		module: BrandStoreChange,
		id: 'BrandStoreChange',
		mainBtnText: null,
		hasXBtn: true,
		fullHeight: true,
		contsTitle: '판매처 일괄 변경',
	},
	ExpressionChange: {
		module: ExpressionChange,
		id: 'ExpressionChange',
		mainBtnText: null,
		hasXBtn: true,
		fullHeight: true,
		contsTitle: '제품표현식',
	},
	EventProductList: {
		module: EventProductList,
		id: 'EventProductList',
		contsTitle: '이벤트 제품 리스트',
	},
	QnaStateBatchBlock: {
		module: QnaStateBatchBlock,
		id: 'QnaStateBatchBlock',
		contsTitle: '일괄차단',
		size: 'wide',
	},
};
